<app-header [host]="host" [cart]="cart"></app-header>

<main class="container">

  <div class="form-group mt-2">
    <label for="id_search" i18n>Search Term</label>
    <div class="input-group">
      <input id="id_search"
             class="form-control"
             type="text"
             i18n-placeholder
             autofocus
             placeholder="e.g. {{ searchExamples }}"
             (keyup)="searchTerm$.next($event.target.value)">
      <div class="input-group-append">
        <button class="btn btn-secondary"><i class="fa fa-search"></i></button>
      </div>
    </div>
  </div>

  <div class="result" *ngIf="result">
    <p *ngIf="result.is_empty()" i18n>
      Did not find any products with "{{ result.term }}". Please try another search term.
    </p>

    <div class="list-group">
      <a [routerLink]="['/grp', group.id]"
         *ngFor="let group of result.groups"
         class="list-group-item list-group-item-action">
        <div class="row">
          <div class="col">{{ group.name }}</div>
          <div class="col col-sm-auto text-right"><i class="fa fa-arrow-right"></i></div>
        </div>
      </a>
    </div>

    <div class="list-group mt-3">
      <a [routerLink]="['/item', item.id]" *ngFor="let item of result.items"
         class="list-group-item list-group-item-action">
        <div class="row">
          <div class="col"><b>{{ item.name }}</b></div>
          <div class="col col-auto text-right">
            <div *ngIf="!item.hasVariants()"><b>{{ item.price|currency:host }}</b></div>
            <div *ngFor="let variant of item.variants">
              {{ variant.name }} <b>{{ variant.price|currency:host }}</b>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>

</main>
